"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionGroup = exports.question_groups = exports.QUESTION_GROUP_DEFINITIONS = void 0;
const company_lmia_question_groups_1 = require("./partials/company-lmia-question-groups");
const general_question_groups_1 = require("./partials/general-question-groups");
const gts_question_groups_1 = require("./partials/gts-question-groups");
const inside_canada_question_groups_1 = require("./partials/inside-canada-question-groups");
const lawyer_question_groups_1 = require("./partials/lawyer-question-groups");
const leads_question_groups_1 = require("./partials/leads-question-groups");
const study_permit_question_groups_1 = require("./partials/study-permit-question-groups");
const visitor_visa_question_groups_1 = require("./partials/visitor-visa-question-groups");
const work_permit_question_groups_1 = require("./partials/work-permit-question-groups");
exports.QUESTION_GROUP_DEFINITIONS = [
    ...gts_question_groups_1.GTS_QUESTION_GROUPS,
    ...study_permit_question_groups_1.STUDY_PERMIT_QUESTION_GROUPS,
    ...lawyer_question_groups_1.LAWYER_QUESTION_GROUPS,
    ...visitor_visa_question_groups_1.VISITOR_VISA_QUESTION_GROUPS,
    ...work_permit_question_groups_1.WORK_PERMIT_QUESTION_GROUPS,
    ...general_question_groups_1.GENERAL_APPLICATION_QUESTION_GROUPS,
    ...inside_canada_question_groups_1.INSIDE_CANADA_APPLICATION_QUESTION_GROUPS,
    ...company_lmia_question_groups_1.COMPANY_LMIA_QUESTION_GROUPS,
    ...company_lmia_question_groups_1.COMPANY_LMIA_ROLE_QUESTION_GROUPS,
    ...company_lmia_question_groups_1.COMPANY_LMIA_GENERAL_APPLICATION_QUESTION_GROUPS,
    ...company_lmia_question_groups_1.COMPANY_LMIA_STREAM_APPLICATION_QUESTION_GROUPS,
    ...company_lmia_question_groups_1.COMPANY_LMIA_USE_OF_REP_QUESTION_GROUPS,
    ...leads_question_groups_1.LEADS_DEFAULT_QUESTION_GROUPS,
];
exports.question_groups = [
    ...exports.QUESTION_GROUP_DEFINITIONS.map(({ title }) => title),
    ...exports.QUESTION_GROUP_DEFINITIONS.map(({ uniqueKey }) => uniqueKey),
];
exports.QuestionGroup = exports.QUESTION_GROUP_DEFINITIONS.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr.title]: curr, [curr.uniqueKey]: curr })), {});
